import __vue_component__ from './TextField.vue.js';

//
var script = {
  name: 'Input',
  components: {
    TextField: __vue_component__
  },
  props: {
    value: {
      type: [Number, String],
      default: undefined
    },
    maxlength: {
      type: Number,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100%'
    },
    type: {
      type: String,
      default: 'text'
    },
    step: {
      type: String,
      default: '1'
    },
    allowedValues: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      isFocused: false
    };
  },

  computed: {
    input: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('input', val);
      }

    }
  },
  watch: {
    input() {
      if (this.allowedValues) {
        this.input = this.input.replace(new RegExp(this.allowedValues, 'g'), '');
      }
    },

    autoFocus: {
      handler(isFocused) {
        if (isFocused) {
          this.$nextTick(() => {
            if (this.$refs.input) {
              this.$refs.input.focus();
            }
          });
        }
      },

      immediate: true
    }
  },
  methods: {
    onFocus(e) {
      this.isFocused = true;
      this.$emit('focus', e);
    },

    onBlur(e) {
      this.isFocused = false;
      this.$emit('blur', e);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Form/Input.vue_rollup-plugin-vue=script.js